import React, { useState, useEffect, useRef, useCallback } from 'react'
import SubNavbar from 'components/SubNavbar'

type Props = {
  hasAlertsCapability: boolean
  hasCurrentStatusCapability: boolean
  hasRthCapability: boolean
  hasSysConfigCapability: boolean
  hasCommunicatingComponentsCapability: boolean
  hasAwairDevice: boolean
  hasConsumerRTH: boolean
  hasMaintenanceTrends: boolean
  hasZoneStatus: boolean
  displayNotesLink: boolean
  showVerificationReportsLink: boolean
  onLinkClickCallback: (label: string) => void
}

const TopNavbar = ({ // todo: delete this file and use SubNavbar directly instead
  hasAlertsCapability,
  hasCurrentStatusCapability,
  hasRthCapability,
  hasSysConfigCapability,
  hasCommunicatingComponentsCapability,
  hasAwairDevice,
  hasConsumerRTH,
  hasMaintenanceTrends,
  hasZoneStatus,
  displayNotesLink,
  showVerificationReportsLink,
  onLinkClickCallback
}:Props) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [isScrolling, setIsScrolling] = useState(false)

  const tabs: { label: string, to: string }[] = []

  if (hasAlertsCapability) { tabs.push({ label: 'Alerts', to: 'alerts' }) }
  if (hasCurrentStatusCapability) { tabs.push({ label: 'System Status', to: 'system-status' }) }
  if (hasZoneStatus) { tabs.push({ label: 'Zone Status', to: 'zone-status' }) }
  if (hasRthCapability) { tabs.push({ label: 'Thermostat Runtime History', to: 'thermostat-runtime-history' }) }
  if (hasAwairDevice) { tabs.push({ label: 'Awair Runtime History', to: 'awair-runtime-history' }) }
  if (hasConsumerRTH) { tabs.push({ label: 'Customer Runtime History', to: 'customer-runtime-history' }) }
  if (hasMaintenanceTrends) { tabs.push({ label: 'Maintenance Trends', to: 'maintenance-trends' }) }
  if (hasSysConfigCapability) { tabs.push({ label: 'System Config', to: 'system-config' }) }
  if (hasCommunicatingComponentsCapability) { tabs.push({ label: 'System Components', to: 'system-components' }) }
  if (showVerificationReportsLink) { tabs.push({ label: 'Link Verification Reports', to: 'link-verification-reports' }) }
  if (displayNotesLink) { tabs.push({ label: 'Notes', to: 'notes' }) }

  const scrollToDiv = (tab) => {
    onLinkClickCallback(tab.label)
    const DevicePanel = document.getElementById(tab.to)

    if (DevicePanel) {
      setIsScrolling(true)
      DevicePanel.scrollIntoView({ behavior: 'smooth' })
      setTimeout(() => {
        setIsScrolling(false)
      }, 1000)
    }
  }

  const sections = useRef<Array<HTMLElement>>([])

  const onScroll = useCallback(() => {
    setIsScrolling(false)
    sections.current = Array.from(document.querySelectorAll('[data-scroll-to-section]'))
    const currentScrollPosition = window.scrollY + 70 // 70px for navbar height and 20px for panel top padding

    let activeSectionIndex
    sections.current.reverse().find((section: HTMLElement, index: number) => {
      const sectionOffsetTop = section.offsetTop
      const numberOfSections = sections.current.length
      const topOfFirstSection = sections.current[numberOfSections - 1]?.offsetTop

      if (currentScrollPosition <= topOfFirstSection) {
        activeSectionIndex = 0
        return true
      } else if (currentScrollPosition >= sectionOffsetTop) {
        activeSectionIndex = sections.current.length - index - 1
        return true
      }

      return false
    })
    setSelectedTab(activeSectionIndex)
  }, [])

  useEffect(() => {
    if (!isScrolling) {
      window.addEventListener('scroll', onScroll)
      return () => {
        window.removeEventListener('scroll', onScroll)
      }
    }
  }, [isScrolling, onScroll])

  return <SubNavbar tabs={tabs} selectedTabIndex={selectedTab} updateActiveTabCallback={setSelectedTab} scrollToDivCallback={scrollToDiv} />
}

export default TopNavbar
